<template>
<!-- TODO: 
   - Only include files with .csv & .parquet extensions.
-->
<!-- HISTORY:
   V260604.1: Implemented the download event of bt-folder-tree for the lake tree.
   V260529.1: Excluded files starting with .nfs from the lake tree (right panel).
   V260212.1: Added Refresh btn + In BtFolderTree, consumed is-power-admin prop and handled delete event.
   V250805.2: Added v-overlay to show progress (instead of error message) while populating s3Tree + Adjusted some paddings.
   V250804.2: Added sortNodesByName() to sort s3Tree and lakeTree nodes + Modified onNodeClick() to pass the correct params to getSchemas() after changing the logic in LsQuery.vue.
   V250722.1: Removed countFiles and added Collapse/Expand btn instead + Consumed BtFolderTree's is-expanded prop.
   V250625.1: Changed the file name/title from File Structure to Folder Structure.
   V250618.1: Obtained and displayed files schemas when lake directory nodes are clicked.
   V250617.1: 1st version/release.
-->
<v-container fluid class="px-3 py-3">
   <v-card class="px-0">
      <v-card-title>
         <h1 class="title font-weight-bold grey--text darken-4 pl-2" style="color:#757575 !important">
            <v-icon class="pr-1">folder_open</v-icon>
            <span>Folder Structure</span>
         </h1>
         <div class="flex-grow-1"></div>
      </v-card-title>
      <v-card-text v-if="s3Tree?.length">
         <v-row>
            <v-col cols="6" class="px-0"><!-- LEFT/Object PANEL -->
               <v-expansion-panels focusable inset
                  v-model="s3Panel"
               >
                  <v-expansion-panel readonly>
                     <v-expansion-panel-header hide-actions>
                        <div class="d-flex justify-space-between align-center w-100">
                           <span>Object Storage</span>
                           <!-- <span class="ml-auto">{{ s3FilesCount }}</span> -->
                        </div>
                     </v-expansion-panel-header>                  
                     <v-expansion-panel-content>
                        <v-card flat
                           class="px-0"
                           :loading="loadingS3Tree"
                        >
                           <v-card-text class="pr-0">
                              <v-row>
                                 <v-col cols="9" class="px-0 py-0">
                                       <!-- :is-power-admin="jwt?.pa || isLocal" -->
                                    <bt-folder-tree v-if="s3Tree?.length"
                                       :nodes="s3Tree"
                                       :is-clickable="false"
                                       :is-expanded="isExpandedL"
                                       @click="onNodeClick"
                                    />
                                    <v-skeleton-loader v-else
                                       type="list-item"
                                    />
                                 </v-col>
                                 <v-col cols="3" class="px-0 py-0 d-flex justify-end">
                                    <v-btn text small
                                       color="blue darken-1"
                                       class="pr-0"
                                       @click="isExpandedL = !isExpandedL"
                                    >{{isExpandedL ? 'Collapse' : 'Expand'}}
                                       <v-icon v-if="isExpandedL" right dark class="ml-0">chevron_right</v-icon>
                                       <v-icon v-else right dark>expand_more</v-icon>
                                    </v-btn>
                                 </v-col>
                              </v-row>
                           </v-card-text>
                        </v-card>
                     </v-expansion-panel-content>
                  </v-expansion-panel>
               </v-expansion-panels>
            </v-col>
            <v-col cols="6" class="px-0"><!-- RIGHT/Containers PANEL -->
               <v-expansion-panels focusable inset
                  v-model="lakePanel"
               >
                  <v-expansion-panel readonly>
                     <v-expansion-panel-header hide-actions>
                        <div class="d-flex justify-space-between align-center w-100">
                           <span>Containers Shared Storage</span>
                           <!-- <span class="ml-auto">{{ lakeFilesCount }}</span> -->
                        </div>
                     </v-expansion-panel-header>
                     <v-expansion-panel-content>
                        <v-card flat
                           class="px-0"
                           :loading="loadingLakeTree"
                        >
                           <v-card-text class="pr-0">
                              <v-row>
                                 <v-col cols="9" class="px-0 py-0">
                                    <!-- V260604: added @download -->
                                    <bt-folder-tree v-if="lakeTree?.length"
                                       :nodes="lakeTree"
                                       :is-clickable="true"
                                       :is-expanded="isExpandedR"
                                       :is-power-admin="jwt?.pa || isLocal"
                                       @click="onNodeClick"
                                       @delete="onNodeDelete"
                                       @download="onFileDownload"
                                    />
                                    <v-skeleton-loader v-else
                                       type="list-item"
                                    />
                                 </v-col>
                                 <v-col cols="3" class="px-0 py-0 d-flex justify-end">
                                    <v-btn text small
                                       color="blue darken-1"
                                       class="pr-0"
                                       :disabled="btnRefreshLakeTreeDisabled"
                                       @click="refreshClicked"
                                    >Refresh{{lakeTreeDisabledDuration ? ' in ' + lakeTreeDisabledDuration + ' sec' : ''}}
                                       <v-icon right dark class="ml-0" v-if="lakeTreeDisabledDuration === 0">refresh</v-icon>
                                    </v-btn>
                                    <v-btn text small
                                       color="blue darken-1"
                                       class="pr-0"
                                       @click="isExpandedR = !isExpandedR"
                                    >{{isExpandedR ? 'Collapse' : 'Expand'}}
                                       <v-icon v-if="isExpandedR" right dark class="ml-0">chevron_right</v-icon>
                                       <v-icon v-else right dark>expand_more</v-icon>
                                    </v-btn>
                                 </v-col>
                              </v-row>
                           </v-card-text>
                        </v-card>
                     </v-expansion-panel-content>
                  </v-expansion-panel>
               </v-expansion-panels>
            </v-col>
         </v-row>
      </v-card-text>
      <v-card-text v-else-if="!loadingS3Tree">
         <v-alert dense outlined
            type="error"
         >There is no file available. Please create one or more ETLs to upload some files.</v-alert>
      </v-card-text>
   </v-card>

   <v-dialog no-click-animation persistent
      max-width="640px"
      v-model="dialogSchemas"
   >
      <v-card flat>
         <v-card-title class="title grey--text darken-4 font-weight-bold pb-2">Schemas for {{clickedNode.year}}:</v-card-title>

         <v-card-text class="pt-2 pb-0">
            <v-data-table dense fixed-header
               class="elevation-1"
               item-key="column_name"
               :footer-props="{
                  itemsPerPageOptions: [5, 10, 20, -1],
                  showFirstLastPage: true
               }"
               :headers="headers"
               :hide-default-footer="schemas.length <= 5"
               :items="schemas"
               :items-per-page="10"
               :loading="loadingSchemas"
               :loading-text="$t('loading-text')"
               :no-data-text="$t('no-data-text', { value: 'schemas' })"
               :no-results-text="$t('no-results-text', { value: 'schemas' })"
               :search="search"
            ></v-data-table>
         </v-card-text>

         <v-card-actions class="pr-4">
            <div class="flex-grow-1"></div>
            <v-btn text
               color="blue darken-1"
               @click="dialogSchemas = false"
            >Close</v-btn>
         </v-card-actions>
      </v-card>
   </v-dialog>

   <v-overlay :value="loadingS3Tree">
      <v-progress-circular
         indeterminate
         size="128"
      ></v-progress-circular>
         &nbsp;&nbsp;Loading data. Please wait...
   </v-overlay>
</v-container>
</template>

<script>
import BtFolderTree from './BtFolderTree.vue';
import { APIService } from '../services/ls-api-service.js';
import { isLocal } from '../mixins/bt-mixin.js';

const NAME = "LsFolderStructure";

export default {
   name: NAME,

   components: {
      BtFolderTree
   },

   props: {
      debug: {
         type: Boolean,
         default: false
      },
      isActualEndpoint: {
         type: Boolean,
         default: true
      }
   },

   data() {
      return {
         isLocal,
         jwt: {},
         apiService: null,
         loadingS3Tree: true,
         loadingLakeTree: false,
         s3Panel: 0,
         lakePanel: 0,
         s3Tree: [],    //V260212: null,
         lakeTree: [],  //V260212: null,
         dialogSchemas: false,
         loadingSchemas: false,
         search: '',
         headers: [
            { text: 'Column Name', value: 'column_name', align: 'left', sortable: true },
            { text: 'Column Type', value: 'column_type', align: 'left', sortable: true }
         ],
         schemas: [],
         clickedNode: {},
         isExpandedL: true,
         isExpandedR: true,
         btnRefreshLakeTreeDisabled: true,   //V260212
         lakeTreeDisabledDuration: 0         //V260212
      }
   },

   computed: {
      token() {
         return this.$store.getters.token;
      },

      // s3FilesCount() {
      //    // alert(this.countFiles(this.s3Tree));
      //    return this.countFiles(this.s3Tree).csv + ' csv';
      // },

      // lakeFilesCount() {
      //    const { csv, parquet } = this.countFiles(this.lakeTree);
      //    return `${csv} csv & ${parquet} parquet`;
      // }
   },

   watch: {
      token() {
         this.init();
      }
   },

   methods: {
      log(msg) {
         if (this.debug)
            console.log(`-----${NAME} V260604.1 says => ${msg}`);
      },

      logout() {
         this.$router.push('/');
      },

      async init() {
         if (this.token) {
            this.jwt = JSON.parse(Buffer.from(this.token.split('.')[1], 'base64'));
            this.apiService = new APIService(this.jwt, this.token, this.debug, this.isActualEndpoint);
            // await sleep(1000);
            await this.getS3Directories();
            if (this.s3Tree.length)
               await this.getLakeDirectories();
         }
      },

      async getS3Directories() {
         this.loadingS3Tree = true;
         let result = await this.apiService.getS3Directories();
         if (result.logout)
            this.logout();
         else if (result.message)
            this.s3Tree = [];
         else {
            this.s3Tree = this.sortNodesByName(result.data);
            // if (process.env.VUE_APP_IS_LOCAL) {
            //    // console.warn('s3Tree=' + JSON.stringify(result.data));
            //    // alert('isLocal=' + process.env.VUE_APP_IS_LOCAL);
            //    this.s3Tree = this.sortNodesByName([
            //       {"name":"2024","type":"directory","path":"27450/2024/",
            //          "children":[
            //             {"name":"10","type":"directory","path":"27450/2024/10/","children":[{"name":"2024_10.csv","type":"file","path":"27450/2024/10/2024_10.csv","size":3819479,"modified":"2025-07-29T20:50:26.000Z"}]},
            //             {"name":"7","type":"directory","path":"27450/2024/7/","children":[{"name":"2024_7.csv","type":"file","path":"27450/2024/7/2024_7.csv","size":3819479,"modified":"2025-07-29T20:50:26.000Z"}]}
            //          ]
            //       },
            //       {"name":"2025","type":"directory","path":"27450/2025/",
            //          "children":[{"name":"1","type":"directory","path":"27450/2025/1/",
            //             "children":[{"name":"2025-01.csv","type":"file","path":"27450/2025/1/2025-01.csv","size":124505,"modified":"2025-05-23T17:59:52.000Z"}]
            //          }]
            //       }
            //    ]);
            // }
         }

         // await sleep(5000);
         this.loadingS3Tree = false;
      },

      async getLakeDirectories() {
         this.loadingLakeTree = true;
         this.btnRefreshLakeTreeDisabled = true;
         this.lakeTreeDisabledDuration = 30;
         let result = await this.apiService.getLakeDirectories();
         this.loadingLakeTree = false;
         if (result.logout)
            this.logout();
         else if (result.message)
            this.lakeTree = [];
         else {
            //V260529: this.lakeTree = this.sortNodesByName(result.data);
            this.lakeTree = this.sortNodesByName(this.filterNodes(result.data));

            // if (process.env.VUE_APP_IS_LOCAL) {
            //    // console.warn('lakeTree=' + JSON.stringify(result.data));
            //    // alert('isLocal=' + process.env.VUE_APP_IS_LOCAL);
            //    this.lakeTree = this.sortNodesByName([
            //       {"name":"2024","type":"directory","size":6144,"modified":"2025-07-29T20:50:25.597Z",
            //          "children":[
            //             {
            //                "name":"11","type":"directory","size":6144,"modified":"2025-07-29T20:50:25.825Z",
            //                "children":[
            //                   {"name":"2024_12.csv","type":"file","size":3819479,"modified":"2025-07-29T20:50:25.753Z"},
            //                   {"name":"2024_7.csv","type":"file","size":3819479,"modified":"2025-07-29T20:50:25.753Z"},
            //                   {"name":"2024_7.parquet","type":"file","size":162379,"modified":"2025-07-29T20:50:25.885Z"}
            //                ]
            //             },
            //             {
            //                "name":"7","type":"directory","size":6144,"modified":"2025-07-29T20:50:25.825Z",
            //                "children":[
            //                   {"name":"2024_7.csv","type":"file","size":3819479,"modified":"2025-07-29T20:50:25.753Z"},
            //                   {"name":"2024_7.parquet","type":"file","size":162379,"modified":"2025-07-29T20:50:25.885Z"},
            //                   {"name":"2024_12.csv","type":"file","size":3819479,"modified":"2025-07-29T20:50:25.753Z"}
            //                ]
            //             }
            //          ]
            //       }
            //    ]);
            // }

            if (this.lakeTree.length) {
               setTimeout(() => {
                  this.btnRefreshLakeTreeDisabled = false;
               }, 1000 * 30);

               const setIntervalLakeTree = setInterval(() => {
                  if (this.lakeTreeDisabledDuration > 0)
                     this.lakeTreeDisabledDuration--;
                  else
                     clearInterval(setIntervalLakeTree);
               }, 1000);
            }
         }
      },

      // countFiles(nodes) {
      //    let count = 0;
      //    nodes?.forEach(node => {
      //       if (node.type === 'file')
      //          count++;
      //       else if (node.children)
      //          count += this.countFiles(node.children);
      //    });
      //    return count;
      // },

      // countFiles(nodes) {
      //    let csvCount = 0;
      //    let parquetCount = 0;

      //    nodes?.forEach(node => {
      //       if (node.type === 'file') {
      //          if (node.name.endsWith('.csv')) csvCount++;
      //          else if (node.name.endsWith('.parquet')) parquetCount++;
      //       } else if (node.type === 'directory' && node.children) {
      //          const childCounts = this.countFiles(node.children);
      //          csvCount += childCounts.csv;
      //          parquetCount += childCounts.parquet;
      //       }
      //    });

      //    return { csv: csvCount, parquet: parquetCount };
      //    // return { csvCount, parquetCount };
      // },

      async onNodeClick({year, month}) {
         // alert(`in ${NAME}.onNodeClick(): year=${year}, month=${month}`);
         this.dialogSchemas = true;
         this.loadingSchemas = true;
         this.schemas = [];
         //V250804: this.clickedNode = year + '/' + (month || '*');
         this.clickedNode = {
            year: `${year}/${month}`,
            month: '|'
         };
         let result = await this.apiService.getSchemas(this.clickedNode);
         this.loadingSchemas = false;
         if (result.logout)
            this.logout();
         else if (!result.message)
            this.schemas = result.data;
      },

      // V260212
      async onNodeDelete({year, month}) {
         // alert(`in ${NAME}.onNodeDelete(): ${year}/${month}`);
         let result = await this.apiService.deleteLakeDirectory(year, month);
         if (result.logout)
            this.logout();
         else if (!result.message) {
            this.$emit('snackbar-event', `The ${year}/${month} folder was deleted from the shared repository.`);
            await this.refreshClicked();
         }
      },
      
      // V260604
      async onFileDownload({ year, month, node }) {
         const result = await this.apiService.downloadLakeRejects(year, month);
         if (result.logout)
            this.logout();
         else if (!result.message) {
            try {
               const url = window.URL.createObjectURL(result.data);  //new Blob([result.data], { type: 'text/csv' })
               const link = document.createElement('a');
               link.href = url;
               link.download = node.name;

               document.body.appendChild(link);
               link.click();

               document.body.removeChild(link);
               window.URL.revokeObjectURL(url);

               // 2nd approach for downloading the file:
               // const handle = await window.showSaveFilePicker({
               //    suggestedName: node.name,
               //    types: [{ description: 'CSV Files', accept: { 'text/csv': ['.csv'] } }]
               // });
               // const writableStream = await handle.createWritable();
               // await result.data.pipeTo(writableStream);
            } catch (err) {
               alert(`User cancelled or download failed!\n${JSON.stringify(err)}`);
            }
         }
      },

      // V250731
      sortNodesByName(nodes) {
         return nodes
            .slice() // avoid in-place mutation
            .sort((a, b) => {
               const aNum = Number(a.name);
               const bNum = Number(b.name);

               if (!isNaN(aNum) && !isNaN(bNum))
                  return aNum - bNum;
               else
                  return a.name.localeCompare(b.name, undefined, { numeric: true });
            }).map(node => {
               const sortedNode = { ...node };
               if (Array.isArray(node.children) && node.children.length) {
                  sortedNode.children = this.sortNodesByName(node.children);
               }
               return sortedNode;
            });
      },

      // V260212
      async refreshClicked() {
         await this.getLakeDirectories();

         if (this.isExpandedR) {
            this.$nextTick(() => {
               this.isExpandedR = false;
               this.$nextTick(() => {
                  this.isExpandedR = true;
               });
            });
         }
      },

      // V260529
      filterNodes(nodes) {
         return nodes
            .filter(node => !node.name.startsWith('.nfs'))
            .map(node => {
               if (Array.isArray(node.children) && node.children.length)
                  return { ...node, children: this.filterNodes(node.children) };
               return node;
            });
      }
   },

   created() { },

   mounted() {
      this.init();
   }
}
</script>